module.exports = __webpack_public_path__ + "static/media/LocationMarker.7330f408.png";